// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#moveCurrentMtpWarningModal .btn {
  border-radius: 30px;
  min-width: 115px;
  box-shadow: none !important;
}
#moveCurrentMtpWarningModal .container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
#moveCurrentMtpWarningModal {
  /* Create a custom checkbox */
}
#moveCurrentMtpWarningModal .checkmark {
  position: absolute;
  margin-left: -15px;
  height: 20px;
  width: 20px;
  border: 2px solid #d0d0d0;
  border-radius: 4px;
}
#moveCurrentMtpWarningModal label {
  font-size: 1.6rem !important;
}
#moveCurrentMtpWarningModal {
  /* When the checkbox is checked, add a blue background */
}
#moveCurrentMtpWarningModal .container input:checked ~ .checkmark {
  background-color: #2196F3;
  border: 2px solid #2196F3;
}
#moveCurrentMtpWarningModal {
  /* Create the checkmark/indicator (hidden when not checked) */
}
#moveCurrentMtpWarningModal .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
#moveCurrentMtpWarningModal {
  /* Show the checkmark when checked */
}
#moveCurrentMtpWarningModal .container input:checked ~ .checkmark:after {
  display: block;
}
#moveCurrentMtpWarningModal {
  /* Style the checkmark/indicator */
}
#moveCurrentMtpWarningModal .container .checkmark:after {
  left: 6px;
  top: 0px;
  width: 5px;
  height: 14px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
#moveCurrentMtpWarningModal .container.radio {
  width: fit-content !important;
  padding: 0 50px;
}
#moveCurrentMtpWarningModal .checkmark {
  margin-left: -26px;
  margin-top: 3px;
}
#moveCurrentMtpWarningModal .btn-link {
  color: #5b5b5b;
  font-weight: bold;
}
#moveCurrentMtpWarningModal .btn-link:hover {
  text-decoration: none;
  color: #5a5a5a;
}
#moveCurrentMtpWarningModal .btn-link:focus {
  text-decoration: none;
}
#moveCurrentMtpWarningModal .btn-secondary {
  border-radius: 0;
  background-color: #b4b4b4;
  box-shadow: none !important;
  border: none;
}
#moveCurrentMtpWarningModal .btn-primary {
  border-radius: 30px;
  min-width: 115px;
  box-shadow: none !important;
  padding: 0.6rem 1.2rem;
  background-color: #007bff;
  border: solid #007bff;
}
#moveCurrentMtpWarningModal .btn-primary:hover {
  background-color: #0062cc;
  border-color: #0062cc;
}
@media (min-width: 2024px) {
#moveCurrentMtpWarningModal #confirmation-modal-label {
    font-size: 3.2rem;
}
}
#moveCurrentMtpWarningModal .invalid-feedback {
  display: block;
}
@media (min-width: 2024px) {
#moveCurrentMtpWarningModal .invalid-feedback span {
    font-size: 1.84rem !important;
}
}
@media (min-width: 2024px) {
#moveCurrentMtpWarningModal .modal-dialog {
    max-width: 700px !important;
}
}
@media (min-width: 2024px) {
#moveCurrentMtpWarningModal .modal-dialog .input-group input {
    font-size: 1.84rem !important;
}
}
@media (min-width: 2024px) {
#moveCurrentMtpWarningModal .modal-dialog .modal-footer button.btn {
    font-size: 1.84rem !important;
}
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
